import * as React from 'react'

import { Box, Popover } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import LeavePill from 'modules/attendance/components/ClockIn/LeavePillWithPopover/LeavePill'
import PopoverRow from 'modules/attendance/components/ClockIn/LeavePillWithPopover/PopoverRow'
import { LeaveInfo } from 'modules/attendance/store/models/CalendarDay'

enum LeaveDayTypes {
  Full = 'full',
  BegginingOfDay = 'beggining_of_day',
  BeginningOfDay = 'beginning_of_day',
  EndOfDay = 'end_of_day',
}

enum LeaveTypes {
  BankHoliday = 'bank_holiday',
  Leave = 'leave',
}

interface Props {
  leaveInfo: LeaveInfo
}

const noToggle = () => () => undefined

const dayTypeDurationText = (dayType: string) => {
  switch (dayType) {
    case LeaveDayTypes.Full:
      return i18n.t('clock_in.off_day_popover.day_type.full')
    case LeaveDayTypes.BegginingOfDay:
    case LeaveDayTypes.BeginningOfDay:
      return i18n.t('clock_in.off_day_popover.day_type.beginning_of_day')
    case LeaveDayTypes.EndOfDay:
      return i18n.t('clock_in.off_day_popover.day_type.end_of_day')
  }
}

function LeavePillWithPopover({ leaveInfo }: Props) {
  const [hover, setHover] = React.useState<boolean>(false)

  const isWorkable = leaveInfo.is_workable
  const hourlyStartTime = leaveInfo.hourly_start_time
  const hoursAmount = leaveInfo.hours_amount
  const minutesAmount = hoursAmount ? Math.round(parseFloat(hoursAmount) * 60) : null
  const duration = minutesAmount ?? dayTypeDurationText(leaveInfo.day_type)

  useEffect(() => {
    if (hover) {
      track(trackingEvents.timeTracking.seeLeaveTooltip)
    }
  }, [hover])

  return (
    <Box inline alignItems="flexStart">
      <Box onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
        <Popover.ItemList gapDivider={false} attachment="top center" open={hover} toggle={noToggle}>
          <Box cursor="pointer">
            <LeavePill leaveInfo={leaveInfo} />
          </Box>
          <PopoverRow label={i18n.t('clock_in.off_day_popover.duration')} value={duration} />
          {leaveInfo.type === LeaveTypes.Leave && (
            <PopoverRow
              label={i18n.t('clock_in.off_day_popover.starts_at')}
              value={hourlyStartTime}
            />
          )}
          {isWorkable && (
            <>
              <Box></Box>
              <PopoverRow label={i18n.t('clock_in.off_day_popover.workable_absence')} value={''} />
            </>
          )}
        </Popover.ItemList>
      </Box>
    </Box>
  )
}

export default observer(LeavePillWithPopover)
